
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/bibliodesk-egzemplarze-ksiazek-uzytkownika",
      function () {
        return require("private-next-pages/docs/bibliodesk-egzemplarze-ksiazek-uzytkownika.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/bibliodesk-egzemplarze-ksiazek-uzytkownika"])
      });
    }
  